import type React from "react";

export interface EventStatusBadgeProps {
	maxCapacity?: number;
	sumExpected?: number;
	primaryColor?: string;
	primaryLightColor?: string;
}

export const EventStatusBadge: React.FC<EventStatusBadgeProps> = ({
	maxCapacity = 0,
	sumExpected = 0,
	primaryColor = "#99CA29",
	primaryLightColor = "#fdfff0",
}) => {
	const reservationStyle: React.CSSProperties = {
		borderColor: primaryColor,
		backgroundColor: primaryColor,
		color: "#FFF",
	};

	const attendedStyle: React.CSSProperties = {
		borderColor: "#21acd7",
		backgroundColor: "#FFF",
		color: primaryColor,
	};

	return (
		<div
			style={{
				display: "flex",
				flexGrow: 1,
				border: `1px solid ${primaryColor}`,
				borderRadius: "0.25rem",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					flexBasis: "50%",
					padding: "8px",
					...reservationStyle,
				}}
			>
				<p style={{ textAlign: "center", margin: 0 }}>予約可能最大人数</p>
				<p style={{ textAlign: "center", fontWeight: "bold", margin: 0 }}>
					<span style={{ fontSize: "20px" }}>{maxCapacity || 0}</span>
					<span>人</span>
				</p>
			</div>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					flexBasis: "50%",
					padding: "8px",
					borderRadius: "0.25rem",
					...attendedStyle,
				}}
			>
				<p style={{ textAlign: "center", margin: 0 }}>予約人数</p>
				<p style={{ textAlign: "center", fontWeight: "bold", margin: 0 }}>
					<span style={{ fontSize: "20px" }}>{sumExpected || 0}</span>
					<span>人</span>
				</p>
			</div>
		</div>
	);
};
